export default __webpack_public_path__ + "static/media/exportacion.09927274.svg";